import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { StyledMainBox } from "../../../../../components/commonComponents/StyledComponents/styled";
import { Close } from "@mui/icons-material";
import CloseButton from "../../../../../components/commonComponents/Buttons/CloseButton";

const FilePreview = ({ open, url, type, fileName, closeModal }) => {

    return (
        <Dialog
            open={open}
            onClose={(e) => {
                e.preventDefault();
            }}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle>Preview: {fileName}</DialogTitle>
            <DialogContent>
                <StyledMainBox component="main">
                    <Box sx={{ display: "flex" }}>
                        {url !== "" && (
                            <>
                                {type === "video" ? (
                                    <video style={{ width: "100%", height: "auto" }} controls muted>
                                        <source src={url} type="video/mp4" />
                                    </video>
                                ) : (
                                    <img style={{ width: "100%", height: "auto" }} src={url} />
                                )}
                            </>
                        )}
                    </Box>
                </StyledMainBox>
            </DialogContent>
            <Box height={20} />
            <DialogActions>
                <Stack direction={"row"} spacing={2}>
                    <CloseButton
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                        }}
                        label="Cancel"
                        icon={<Close />}
                    />
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default FilePreview;
